export const ORDER_TYPE = {
    TRANSFER_WAREHOUSE: 'TWH',
    REG: 'REG'
}
